import { render } from "./FormEditPage.vue?vue&type=template&id=712940ce&scoped=true"
import script from "./FormEditPage.vue?vue&type=script&lang=js"
export * from "./FormEditPage.vue?vue&type=script&lang=js"

import "./FormEditPage.vue?vue&type=style&index=0&id=712940ce&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712940ce"]])

export default __exports__